import { useEffect, useMemo } from 'react';
import { isSameDay, createRawTimeValues } from '../../../../util/calendar';

export const useTimePicker = ({
    pickupDate,
    returnDate,
    pickupTime,
    returnTime,
    onReturnTimeChange,
    interval = 30,
}: {
    pickupDate: Date;
    returnDate: Date;
    pickupTime: string;
    returnTime: string;
    onReturnTimeChange: (value: string) => void;
    interval?: number;
}) => {
    const allTimes = useMemo(() => createRawTimeValues(interval), [interval]);
    const sameDay = isSameDay(pickupDate, returnDate);

    useEffect(() => {
        if (!sameDay || !pickupTime || !returnTime) return;

        if (returnTime <= pickupTime) {
            const next = allTimes.find((time) => time > pickupTime);
            if (next && next !== returnTime) {
                setTimeout(() => {
                    onReturnTimeChange(next);
                }, 0);
            }
        }
    }, [pickupTime, returnTime, sameDay, interval, allTimes, onReturnTimeChange]);

    const returnTimeOptions = useMemo(() => {
        return sameDay ? allTimes.filter((time) => time > pickupTime) : allTimes;
    }, [sameDay, allTimes, pickupTime]);

    return {
        allTimes,
        returnTimeOptions,
    };
};
